import { SpaqFireDb } from './spaq-fire-db.service';
import { Injectable } from '@angular/core';

import { ServiceInfo, ServiceMetaInfo } from './shared-constants';
import { combineLatest, from } from 'rxjs';
import { map, mergeMap, toArray } from 'rxjs/operators';

@Injectable()
export class ServicesService {
	constructor(private db: SpaqFireDb) {}

	decrementCapacity(serviceId: number) {
		return this.db.decrementCapacity(serviceId);
	}

	reserveCapacity(newServiceId: number, uid: string) {
		return this.db.reserveCapacity(newServiceId, uid);
	}

	capacitySystem$<T>() {
		return this.db.capacitySystem$<T>();
	}

	hydrate() {
		return combineLatest(this.db.services$<ServiceInfo>(), this.db.servicesMeta$<{ [key: string]: ServiceMetaInfo }>()).pipe(
			mergeMap(([services, meta]) =>
				from(services).pipe(
					map((s: ServiceInfo) => ({ ...s, meta: (meta && meta[s.availableServiceId]) || null })),
					toArray()
				)
			)
		);
	}
}
